import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Button from 'components/utils/button';
import { controls as config } from 'config';
import storage from 'utils/data/storage';
import layout from 'utils/layout';

const propTypes = {
  enabled: PropTypes.bool,
};

const defaultProps = {
  enabled: false,
};

const Download = () => {
  const [downloadUrl, setDownloadUrl] = useState(null);
  const [downloadAttribute, setDownloadAttribute] = useState(null);

  useEffect(() => {
    const id = storage.metadata.id;
    const urls = [
      {
        url: `https://bbb.iut.ac.ir/video/${id}/video-0.m4v`,
        filename: `${id}.m4v`,
      },
      {
        url: `https://bbb.iut.ac.ir/record/${id}.mp4`,
        filename: `${id}.mp4`,
      },
    ];

    const checkUrls = async () => {
      for (const item of urls) {
        try {
          const response = await fetch(item.url, {
            method: 'HEAD',
            redirect: 'follow',
          });

          if (response.ok) {
            setDownloadUrl(item.url);
            setDownloadAttribute(item.filename)
            return;
          }
        } catch {
        }
      }
    };

    checkUrls();
  }, []);

  if (!downloadUrl) return null;

  if (!layout.control && config.swap && !layout.single) return null;

  return (
    <a href={downloadUrl} target="_blank" download={downloadAttribute}>
      <Button
          circle
          handleOnClick={() => {}}
          icon="download"
      />
    </a>
  );
};

Download.propTypes = propTypes;
Download.defaultProps = defaultProps;

export default Download;
